import { skipToken } from '@tanstack/react-query';

import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useSegmentRefusalPictureV1ControllerGetByRefusal } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetRefusalPicturesData = (refusalId: string | undefined) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityScan);

  const { data, error, isLoading } =
    useSegmentRefusalPictureV1ControllerGetByRefusal(
      refusalId
        ? {
            queryParams: { refusalId },
            headers: restHeaders,
          }
        : skipToken,
    );

  return {
    data,
    isLoading,
    error,
  };
};
